import React from 'react';

function SummaryCard({ label, value, colorClass = '' }) {
  return (
    <div className="bg-gray-50 rounded-lg shadow p-2 flex-1 min-w-[120px] sm:w-56 flex flex-col items-center">
      <div className="text-xs text-gray-500 font-semibold mb-1 whitespace-nowrap">{label}</div>
      <div className={`text-base font-bold ${colorClass}`}>{value}</div>
    </div>
  );
}

export default SummaryCard;
